var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow-1 d-flex flex-column align-center",staticStyle:{"height":"100%","background-color":"rgb(250, 250, 250)"}},[_c('PlayerRegistration')],1)}
var staticRenderFns = []

export { render, staticRenderFns }